import React from "react";
import "./Home.scss";

import Background from "../background_1.jpg";

export default class extends React.Component {
	render() {
		return (
			<div className="MainPage">
				<div className="Background" style={{ backgroundImage: `url(${Background})` }}>
					<div className="Overlay"/>
				</div>

				<div className="Head">
					<div className="Title">Hello!</div>
					<div className="Description">This is my art shop!</div>
					<div className="Description" style={{ animationDelay: "3.5s" }}>You can view my commission prices <a href="#/commissions">here</a>.</div>
				</div>
			</div>
		);
	}
}